module.exports = __webpack_public_path__ + "static/partners-b53bcea790304a60e59bf1d4747c130f.png";